import { FREQUENCY_ADJECTIVE } from './frequencies.js';

// Derived word forms for config.Vocabulary (Term + TermGender + Verb).
// Legal texts (privacy policy, LGPD opt-in, reCAPTCHA) intentionally do
// NOT interpolate the vocabulary.

const DEFAULT_TERM = 'doação';
const DEFAULT_VERB = 'doar';

function capitalize(value) {
  return value.charAt(0).toUpperCase() + value.slice(1);
}

export function getVocabulary(config) {
  const vocab = config?.Vocabulary || {};
  const term = (vocab.Term || '').trim() || DEFAULT_TERM;
  const verb = (vocab.Verb || '').trim() || DEFAULT_VERB;
  const masculine = vocab.TermGender === 'Masculine';

  return {
    term,
    termCapitalized: capitalize(term),
    verb,
    verbCapitalized: capitalize(verb),
    your: masculine ? 'seu' : 'sua',
    my: masculine ? 'meu' : 'minha',
    an: masculine ? 'um' : 'uma',
    the: masculine ? 'o' : 'a',
    ofThe: masculine ? 'do' : 'da',
    oneTimeAdjective: masculine ? 'único' : 'única',
    masculine
  };
}

export function frequencyAdjective(frequencyId, vocabulary) {
  if (frequencyId === 'OneTime') {
    return vocabulary.oneTimeAdjective;
  }

  return FREQUENCY_ADJECTIVE[frequencyId] || '';
}
